var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-input',{attrs:{"id":"flags","placeholder":_vm.placeholder || '',"size":"sm","value":_vm.selectedTitle,"readonly":""}}),_c('b-popover',{attrs:{"target":"flags","triggers":"focus","placement":"bottom"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }